/* predictive-search.js — as-you-type product suggestions (Shopify Predictive Search API). */
(function () {
  "use strict";
  var input = document.querySelector("[data-predictive-input]");
  var results = document.querySelector("[data-predictive-results]");
  if (!input || !results) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var timer = null;
  var lastQ = "";

  function esc(s) {
    return (s || "").replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  function hide() {
    results.hidden = true;
  }
  function priceOf(p) {
    if (typeof p.price === "string" && p.price) return p.price;
    if (typeof p.price === "number") return "$" + (p.price / 100).toFixed(2);
    if (p.variants && p.variants[0] && p.variants[0].price) {
      var v = p.variants[0].price;
      return typeof v === "number" ? "$" + (v / 100).toFixed(2) : v;
    }
    return "";
  }
  function imgOf(p) {
    if (typeof p.image === "string") return p.image;
    if (p.featured_image && p.featured_image.url) return p.featured_image.url;
    if (p.image && p.image.url) return p.image.url;
    return "";
  }
  function render(products, q) {
    var html = "";
    if (!products.length) {
      html = '<p class="predictive__empty">No matches for &ldquo;' + esc(q) + '&rdquo;</p>';
    } else {
      html = products
        .map(function (p) {
          var img = imgOf(p);
          var price = priceOf(p);
          return (
            '<a class="predictive__item" href="' + p.url + '" role="option">' +
            (img ? '<img class="predictive__thumb" src="' + img + '" alt="" width="44" height="44" loading="lazy">' : '<span class="predictive__thumb"></span>') +
            '<span class="predictive__title">' + esc(p.title) + "</span>" +
            (price ? '<span class="predictive__price">' + esc(price) + "</span>" : "") +
            "</a>"
          );
        })
        .join("");
      html += '<a class="predictive__all" href="' + ROOT + "search?q=" + encodeURIComponent(q) + '">See all results for &ldquo;' + esc(q) + '&rdquo;</a>';
    }
    results.innerHTML = html;
    results.hidden = false;
  }
  function search(q) {
    var url = ROOT + "search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=6";
    fetch(url, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (q !== lastQ) return; // stale response
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        render(products, q);
      })
      .catch(function () { hide(); });
  }

  input.addEventListener("input", function () {
    var q = input.value.trim();
    lastQ = q;
    clearTimeout(timer);
    if (q.length < 2) { hide(); return; }
    timer = setTimeout(function () { search(q); }, 250);
  });
  input.addEventListener("focus", function () {
    if (input.value.trim().length >= 2 && results.innerHTML) results.hidden = false;
  });
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".header__search")) hide();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { hide(); input.blur(); }
  });
})();
